<template>
  <div class="page-col">
    <div class="page-main">
      <div class="list-header-premium d-flex flex-column flex-xl-row align-items-center justify-content-between gap-3 mb-4" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center">
          <div class="header-icon-wrapper mr-3" style="background: linear-gradient(135deg, #17a2b8 0%, #117a8b 100%);">
            <i class="fa fa-file-text-o text-white"></i>
          </div>
          <div>
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Manutencao de Notas Sefaz</h4>
            <span class="text-muted small">Gerencie a distribuicao de NF-e, de ciencia e manifeste notas recebidas</span>
          </div>
        </div>

        <div class="d-flex align-items-center gap-2">
          <div class="d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border flex-wrap">
            <b-button-group class="mr-1">
              <b-button variant="link" class="btn-icon-only text-muted" @click="filtro.avancado = !filtro.avancado" v-b-tooltip.hover title="Filtros Avancados">
                <i class="fa fa-filter" :class="{ 'text-primary': filtro.avancado }"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir">
                <i class="fa fa-print"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Excel">
                <i class="fa fa-file-excel-o"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-muted" @click="exportarCsv()" v-b-tooltip.hover title="CSV">
                <i class="fa fa-file-text-o"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltros()" v-b-tooltip.hover title="Limpar Filtros">
                <i class="fa fa-ban"></i>
              </b-button>
            </b-button-group>

            <div class="d-flex align-items-center px-2 border-left mr-1">
              <CecInputData ref="dt1" v-model="dt1" class="mx-1" style="width: 145px" placeholder="Inicio" />
              <span class="text-muted mx-1">ate</span>
              <CecInputData ref="dt2" v-model="dt2" class="mx-1" style="width: 145px" placeholder="Fim" />
            </div>

            <div class="d-flex align-items-center px-2 border-left mr-1" style="min-width: 320px">
              <b-form-input
                v-model="filtro.chaveAcesso"
                placeholder="Chave de acesso..."
                class="border-0 bg-transparent py-0"
                @keydown.enter="pesquisar()"
              />
            </div>

            <div class="d-flex align-items-center px-2 border-left mr-1" style="min-width: 220px">
              <b-form-select
                v-model="filtro.associacaoCompra"
                :options="optionsAssociacaoCompra"
                class="border-0 bg-transparent py-0"
              />
            </div>

            <b-button variant="info" pill class="px-4 font-weight-bold shadow-sm text-white" :disabled="isBusy" @click="pesquisar()">
              <i class="fa fa-search mr-1"></i> FILTRAR
            </b-button>
          </div>
        </div>
      </div>

      <b-collapse v-model="filtro.avancado">
        <b-card class="card-filter-premium mb-4 border-0 shadow-sm" :class="{'bg-dark border-secondary text-white': isDark}">
          <div class="modal-section-title mb-3" :class="{'text-white': isDark}">Parametros Adicionais de Filtro</div>
          <b-row align-v="end">
            <b-col md="3" class="mb-3">
              <label class="modal-label-premium">Tipo de Arquivo</label>
              <b-form-select v-model="filtro.tipoArquivo" :options="optionsTipoArquivo" class="rounded-pill shadow-xs border-0 bg-light" />
            </b-col>
            <b-col md="3" class="mb-3">
              <label class="modal-label-premium">Situacao de Manifesto</label>
              <b-form-select v-model="filtro.statusManifesto" :options="optionsStatusManifesto" class="rounded-pill shadow-xs border-0 bg-light" />
            </b-col>
            <b-col md="3" class="mb-3">
              <label class="modal-label-premium">Associacao com Compra</label>
              <b-form-select v-model="filtro.associacaoCompra" :options="optionsAssociacaoCompra" class="rounded-pill shadow-xs border-0 bg-light" />
            </b-col>
            <b-col md="3" class="mb-3 text-right">
              <b-button variant="outline-danger" pill class="px-3" @click="limparFiltros()">
                LIMPAR
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-collapse>

      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-2">
          <div class="bg-white rounded border shadow-sm overflow-hidden">
            <b-table
              ref="tbl"
              class="table-finance table-distribuicao-compacta mb-0"
              :head-variant="isDark ? 'dark' : 'light'"
              :dark="isDark"
              :busy.sync="isBusy"
              :items="itensFiltrados"
              :fields="colunas"
              :current-page="currentPage"
              :per-page="perPage"
              :sticky-header="stickyHeight"
              hover
              small
              responsive
              bordered
              show-empty
              empty-text="Nenhuma nota fiscal de distribuicao encontrada"
            >
              <template #head(NSU)>
                <SetFilter label="NSU" v-model="filtros.NSU" :options="opcoes.NSU" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(CHAVE_ACESSO)>
                <SetFilter label="Chave de Acesso" v-model="filtros.CHAVE_ACESSO" :options="opcoes.CHAVE_ACESSO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(DATA_NFE)>
                <SetFilter label="Emissao" v-model="filtros.DATA_NFE" :options="opcoes.DATA_NFE" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(CNPJ)>
                <SetFilter label="CNPJ Fornecedor" v-model="filtros.CNPJ" :options="opcoes.CNPJ" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(FORNECEDOR)>
                <SetFilter label="Fornecedor" v-model="filtros.FORNECEDOR" :options="opcoes.FORNECEDOR" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(TIPO_ARQUIVO)>
                <SetFilter label="Arquivo" v-model="filtros.TIPO_ARQUIVO" :options="opcoes.TIPO_ARQUIVO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(OP_CIENCIA)>
                <SetFilter label="Ciencia" v-model="filtros.OP_CIENCIA" :options="opcoes.OP_CIENCIA" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(OP_TIPO_MANIFESTACAO)>
                <SetFilter label="Manifesto" v-model="filtros.OP_TIPO_MANIFESTACAO" :options="opcoes.OP_TIPO_MANIFESTACAO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(PEDIDO_COMPRA_ID)>
                <SetFilter label="Assoc. Compra" v-model="filtros.PEDIDO_COMPRA_ID" :options="opcoes.PEDIDO_COMPRA_ID" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #cell(ACOES)="row">
                <div class="d-flex align-items-center justify-content-center gap-1">
                  <b-button
                    v-if="row.item.TIPO_ARQUIVO === 'Nota Completa'"
                    variant="soft-info"
                    size="sm"
                    class="btn-icon-only rounded-circle"
                    @click="toggleDetalhes(row)"
                    v-b-tooltip.hover
                    title="Visualizar Itens"
                  >
                    <i :class="row.detailsShowing ? 'fa fa-angle-up' : 'fa fa-angle-down'"></i>
                  </b-button>

                  <b-button
                    v-if="row.item.OP_CIENCIA !== '1'"
                    variant="success"
                    size="sm"
                    class="btn-icon-only rounded-circle"
                    @click="darCiencia(row.item)"
                    :disabled="!hasCienciaPermission"
                    v-b-tooltip.hover
                    title="Dar Ciencia da Operacao"
                  >
                    <i class="fa fa-check-circle-o"></i>
                  </b-button>

                  <b-dropdown
                    size="sm"
                    variant="link"
                    class="p-0 border-0"
                    no-caret
                    toggle-class="btn-icon-only rounded-circle text-info p-0"
                    :disabled="!hasManifestoPermission"
                  >
                    <template #button-content>
                      <i class="fa fa-bullhorn" v-b-tooltip.hover title="Manifestar Operacao"></i>
                    </template>
                    <b-dropdown-item @click="confirmarManifestar(row.item, 210200)">
                      <i class="fa fa-check text-success mr-2"></i> Confirmar Operacao
                    </b-dropdown-item>
                    <b-dropdown-item @click="abrirModalJustificativa(row.item, 210220)">
                      <i class="fa fa-question-circle text-danger mr-2"></i> Desconhecer Operacao
                    </b-dropdown-item>
                    <b-dropdown-item @click="abrirModalJustificativa(row.item, 210240)">
                      <i class="fa fa-times-circle text-warning mr-2"></i> Operacao nao Realizada
                    </b-dropdown-item>
                  </b-dropdown>

                  <b-button
                    v-if="row.item.TIPO_ARQUIVO === 'Nota Parcial' && row.item.OP_CIENCIA === '1'"
                    variant="primary"
                    size="sm"
                    class="btn-icon-only rounded-circle text-white"
                    @click="baixarPorChave(row.item)"
                    v-b-tooltip.hover
                    title="Baixar XML Completo Sefaz"
                  >
                    <i class="fa fa-cloud-download"></i>
                  </b-button>

                  <b-button
                    v-if="row.item.TIPO_ARQUIVO === 'Nota Completa'"
                    variant="soft-danger"
                    size="sm"
                    class="btn-icon-only rounded-circle"
                    @click="visualizarDanfe(row.item)"
                    v-b-tooltip.hover
                    title="Visualizar DANFE"
                  >
                    <i class="fa fa-file-pdf-o"></i>
                  </b-button>

                  <b-button
                    v-if="row.item.TIPO_ARQUIVO === 'Nota Completa'"
                    variant="soft-primary"
                    size="sm"
                    class="btn-icon-only rounded-circle"
                    @click="downloadXMLFisico(row.item)"
                    v-b-tooltip.hover
                    title="Download XML"
                  >
                    <i class="fa fa-download"></i>
                  </b-button>
                </div>
              </template>

              <template #cell(DATA_NFE)="data">
                <span>{{ formatarData(data.value) }}</span>
              </template>

              <template #cell(CHAVE_ACESSO)="data">
                <span class="small text-monospace">{{ data.value }}</span>
              </template>

              <template #cell(VALOR)="data">
                <span class="font-weight-bold">{{ formatarValor(data.value) }}</span>
              </template>

              <template #cell(TIPO_ARQUIVO)="data">
                <b-badge :variant="data.value === 'Nota Completa' ? 'success' : 'warning'" pill class="px-2 py-1">
                  {{ data.value }}
                </b-badge>
              </template>

              <template #cell(OP_CIENCIA)="data">
                <b-badge :variant="data.value === '1' ? 'success' : 'danger'" pill class="px-2 py-1">
                  {{ data.value === '1' ? 'Sim' : 'Nao' }}
                </b-badge>
              </template>

              <template #cell(OP_TIPO_MANIFESTACAO)="data">
                <b-badge :variant="traduzirManifestoCor(data.value)" pill class="px-2 py-1">
                  {{ traduzirManifesto(data.value) }}
                </b-badge>
              </template>

              <template #cell(PEDIDO_COMPRA_ID)="data">
                <span v-if="data.value">
                  <router-link :to="`/movimentos/compras/edit/${data.value}`" class="text-info font-weight-bold">
                    Compra #{{ data.item.NUM_PEDIDO_COMPRA || data.value }}
                  </router-link>
                </span>
                <span v-else class="text-muted small">Nao Vinculada</span>
              </template>

              <template #row-details="row">
                <div class="p-3 bg-light border-top">
                  <div v-if="row.item.loadingItens" class="text-center p-3">
                    <b-spinner small variant="info" class="mr-2"></b-spinner>
                    <span>Carregando itens da nota fiscal...</span>
                  </div>
                  <div v-else-if="!row.item.itens || row.item.itens.length === 0" class="text-center text-muted p-2">
                    Nenhum item localizado para esta nota.
                  </div>
                  <div v-else>
                    <h6 class="font-weight-bold mb-2 text-info">Itens da Nota Fiscal</h6>
                    <b-table
                      striped
                      hover
                      small
                      bordered
                      class="bg-white rounded table-distribuicao-compacta"
                      :items="row.item.itens"
                      :fields="fieldsItens"
                    >
                      <template #cell(VL_UNT)="d">
                        <span>{{ formatarValor(d.value) }}</span>
                      </template>
                      <template #cell(VL_TOTAL)="d">
                        <span class="font-weight-bold">{{ formatarValor(d.value) }}</span>
                      </template>
                    </b-table>
                  </div>
                </div>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-modal
      ref="modalJustificativa"
      id="modal-justificativa"
      title="Justificativa da Manifestacao"
      centered
      hide-header-close
      no-close-on-backdrop
      @ok="executarManifestarComJustificativa"
    >
      <div class="p-2">
        <p class="text-muted small">
          Insira abaixo uma justificativa para esta manifestacao na SEFAZ (minimo de 15 caracteres):
        </p>
        <b-form-textarea
          v-model="justificativaTexto"
          placeholder="Justificativa da manifestacao..."
          rows="3"
          required
        ></b-form-textarea>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <b-button variant="secondary" pill class="px-4" @click="cancel()">
          CANCELAR
        </b-button>
        <b-button
          variant="primary"
          pill
          class="px-4"
          :disabled="justificativaTexto.trim().length < 15"
          @click="ok()"
        >
          CONFIRMAR
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import CecInputData from '@/components/Cec/CecInputData.vue'
import SetFilter from '@/components/Cec/SetFilter.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import Tools from '@/tools/tools.js'
import { exportCsv, exportExcelXlsx, printHtmlReport } from '@/utils/RelatorioHTML'

export default {
  name: 'NfeDistribuicao',
  components: {
    CecInputData,
    SetFilter
  },
  mixins: [createCecTableToolsMixin({
    rowsProp: 'notas',
    tblRef: 'tbl',
    useExternalPaging: false,
    filters: [
      { key: 'NSU', type: 'string', label: 'NSU' },
      { key: 'CHAVE_ACESSO', type: 'string', label: 'Chave de Acesso' },
      { key: 'DATA_NFE', type: 'date', label: 'Emissao' },
      { key: 'CNPJ', type: 'string', label: 'CNPJ Fornecedor' },
      { key: 'FORNECEDOR', type: 'string', label: 'Fornecedor' },
      { key: 'TIPO_ARQUIVO', type: 'string', label: 'Arquivo' },
      {
        key: 'OP_CIENCIA',
        type: 'string',
        label: 'Ciencia',
        toText: (value) => String(value || '0') === '1' ? 'Sim' : 'Nao'
      },
      {
        key: 'OP_TIPO_MANIFESTACAO',
        type: 'string',
        label: 'Manifesto',
        toText: (value) => {
          if (!value || value === 'null' || value === 'undefined') return 'Nao Manifestado'
          const mapa = {
            '1': 'Confirmacao da Operacao',
            '2': 'Ciencia da Operacao',
            '3': 'Desconhecimento da Operacao',
            '4': 'Operacao nao Realizada'
          }
          return mapa[String(value)] || String(value)
        }
      },
      {
        key: 'PEDIDO_COMPRA_ID',
        type: 'string',
        label: 'Assoc. Compra',
        toText: (value) => {
          if (!value || value === 'null' || value === 'undefined') return 'Nao Associada'
          return `Compra #${value}`
        }
      }
    ]
  })],
  data() {
    return {
      isBusy: false,
      notas: [],
      dt1: null,
      dt2: null,
      filtro: {
        avancado: false,
        chaveAcesso: '',
        tipoArquivo: '',
        statusManifesto: '',
        associacaoCompra: ''
      },
      hasCienciaPermission: true,
      hasManifestoPermission: true,
      justificativaTexto: '',
      justificativaNota: null,
      justificativaTipo: null,
      colunas: [
        { key: 'NSU', label: 'NSU', sortable: true, class: 'text-center align-middle', thStyle: { width: '120px' } },
        { key: 'CHAVE_ACESSO', label: 'Chave de Acesso', sortable: true, class: 'align-middle', thStyle: { width: '280px' } },
        { key: 'DATA_NFE', label: 'Emissao', sortable: true, class: 'text-center align-middle', thStyle: { width: '120px' } },
        { key: 'CNPJ', label: 'CNPJ Fornecedor', sortable: true, class: 'text-center align-middle', thStyle: { width: '160px' } },
        { key: 'FORNECEDOR', label: 'Fornecedor', sortable: true, class: 'align-middle' },
        { key: 'VALOR', label: 'Valor (R$)', sortable: true, class: 'text-right align-middle', thStyle: { width: '120px' } },
        { key: 'TIPO_ARQUIVO', label: 'Arquivo', sortable: true, class: 'text-center align-middle', thStyle: { width: '130px' } },
        { key: 'OP_CIENCIA', label: 'Ciencia', sortable: true, class: 'text-center align-middle', thStyle: { width: '100px' } },
        { key: 'OP_TIPO_MANIFESTACAO', label: 'Manifesto', sortable: true, class: 'text-center align-middle', thStyle: { width: '150px' } },
        { key: 'PEDIDO_COMPRA_ID', label: 'Assoc. Compra', sortable: true, class: 'text-center align-middle', thStyle: { width: '130px' } },
        { key: 'ACOES', label: 'Acoes', class: 'text-center align-middle', thStyle: { width: '150px' } }
      ],
      fieldsItens: [
        { key: 'CODIGO_PRODUTO', label: 'Cod. XML', class: 'text-center align-middle' },
        { key: 'PRODUTO', label: 'Produto (Sefaz)', class: 'align-middle' },
        { key: 'EAN', label: 'GTIN / EAN', class: 'text-center align-middle' },
        { key: 'UND', label: 'Unidade', class: 'text-center align-middle' },
        { key: 'QUANT', label: 'Quantidade', class: 'text-center align-middle' },
        { key: 'VL_UNT', label: 'Val. Unitario', class: 'text-right align-middle' },
        { key: 'VL_TOTAL', label: 'Val. Total', class: 'text-right align-middle' }
      ],
      optionsTipoArquivo: [
        { value: '', text: 'Todos' },
        { value: 'Nota Completa', text: 'Nota Completa' },
        { value: 'Nota Parcial', text: 'Nota Parcial' }
      ],
      optionsStatusManifesto: [
        { value: '', text: 'Todos' },
        { value: 'cientizada', text: 'Cientizadas' },
        { value: 'nao_cientizada', text: 'Nao Cientizadas' },
        { value: 'manifestada', text: 'Manifestadas' },
        { value: 'nao_manifestada', text: 'Nao Manifestadas' },
        { value: 'desconhecida', text: 'Desconhecidas' }
      ],
      optionsAssociacaoCompra: [
        { value: '', text: 'Todas' },
        { value: 'associadas', text: 'Associadas a Compras' },
        { value: 'nao_associadas', text: 'Nao associadas' }
      ]
    }
  },
  computed: {
    isDark() {
      return this.$store.getters['tema/IS_DARK']
    },
    colunasExportacao() {
      return [
        { key: 'NSU', label: 'NSU' },
        { key: 'CHAVE_ACESSO', label: 'Chave de Acesso' },
        { key: 'DATA_NFE', label: 'Emissao', formatter: (value) => this.formatarData(value) },
        { key: 'CNPJ', label: 'CNPJ Fornecedor' },
        { key: 'FORNECEDOR', label: 'Fornecedor' },
        { key: 'VALOR', label: 'Valor (R$)', align: 'right', formatter: (value) => this.formatarValor(value) },
        { key: 'TIPO_ARQUIVO', label: 'Arquivo' },
        { key: 'OP_CIENCIA', label: 'Ciencia', formatter: (value) => String(value || '0') === '1' ? 'Sim' : 'Nao' },
        { key: 'OP_TIPO_MANIFESTACAO', label: 'Manifesto', formatter: (value) => this.traduzirManifesto(value) },
        {
          key: 'PEDIDO_COMPRA_ID',
          label: 'Assoc. Compra',
          formatter: (value, row) => value ? `Compra #${row.NUM_PEDIDO_COMPRA || value}` : 'Nao Vinculada'
        }
      ]
    },
    observacoesRelatorio() {
      const filtros = []
      filtros.push(`Periodo: ${this.dt1 || '---'} ate ${this.dt2 || '---'}`)
      if (this.filtro.chaveAcesso) filtros.push(`Chave de acesso: ${this.filtro.chaveAcesso}`)
      if (this.filtro.tipoArquivo) filtros.push(`Tipo de arquivo: ${this.filtro.tipoArquivo}`)
      if (this.filtro.statusManifesto) filtros.push(`Manifesto: ${this.getTextoStatusManifesto(this.filtro.statusManifesto)}`)
      if (this.filtro.associacaoCompra) filtros.push(`Associacao: ${this.getTextoAssociacaoCompra(this.filtro.associacaoCompra)}`)
      return filtros.join('\n')
    }
  },
  created() {
    this.definirPeriodoPadrao()
  },
  mounted() {
    this.pesquisar()
  },
  methods: {
    definirPeriodoPadrao() {
      const hoje = new Date()
      const trintaDiasAtras = new Date(hoje.getTime() - (30 * 24 * 60 * 60 * 1000))
      this.dt1 = Tools.formatarDataParaInput(trintaDiasAtras)
      this.dt2 = Tools.formatarDataParaInput(hoje)
    },
    async pesquisar() {
      try {
        this.$store.commit('controle/setAguardando', true)
        this.isBusy = true

        const body = {
          cnpjDestinatario: null,
          chaveAcesso: this.somenteNumeros(this.filtro.chaveAcesso),
          tipoArquivo: this.filtro.tipoArquivo,
          statusManifesto: this.filtro.statusManifesto,
          associacaoCompra: this.filtro.associacaoCompra,
          dt1: this.dt1 || null,
          dt2: this.dt2 || null
        }

        const response = await this.$http.post('/api/protected/notaFiscal/distribuicao/listar', body)
        this.notas = (response.data || []).map(item => ({
          ...item,
          loadingItens: false,
          itens: []
        }))
        this.onClear()
      } catch (error) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', error)
      } finally {
        this.isBusy = false
        this.$store.commit('controle/setAguardando', false)
      }
    },
    limparFiltros() {
      this.filtro.chaveAcesso = ''
      this.filtro.tipoArquivo = ''
      this.filtro.statusManifesto = ''
      this.filtro.associacaoCompra = ''
      this.filtro.avancado = false
      this.definirPeriodoPadrao()
      this.onClear()
      this.pesquisar()
    },
    async toggleDetalhes(row) {
      const vaiAbrir = !row.detailsShowing
      row.toggleDetails()

      if (vaiAbrir && (!row.item.itens || row.item.itens.length === 0)) {
        row.item.loadingItens = true
        try {
          const response = await this.$http.get(`/api/protected/notaFiscal/distribuicao/itens/${row.item.ID}`)
          row.item.itens = response.data || []
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Erro ao carregar itens da nota.')
        } finally {
          row.item.loadingItens = false
        }
      }
    },
    async darCiencia(item) {
      const confirmou = await this.$bvModal.msgBoxConfirm('Deseja transmitir o evento de Ciencia da Operacao para esta NF-e?', {
        title: 'Ciencia da Operacao',
        okVariant: 'success',
        okTitle: 'SIM',
        cancelTitle: 'NAO',
        centered: true
      })

      if (!confirmou) return

      try {
        this.$store.commit('controle/setAguardando', true)
        const response = await this.$http.post('/api/protected/notaFiscal/distribuicao/darCiencia', {
          chaveAcesso: item.CHAVE_ACESSO,
          empresaId: item.EMPRESA_ID || 1,
          usuario: window.localStorage.getItem('login') || 'web'
        }, {
          headers: { login: window.localStorage.getItem('login') }
        })

        if (response.data?.sucesso) {
          Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Ciencia da Operacao enviada e registrada!')
          this.pesquisar()
        }
      } catch (error) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Falha ao dar Ciencia: ' + (error.response?.data || error.message || error))
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async confirmarManifestar(item, tipo) {
      const desc = this.traduzirManifesto(String(tipo))
      const confirmou = await this.$bvModal.msgBoxConfirm(`Deseja transmitir o evento de "${desc}" para esta NF-e?`, {
        title: 'Manifestacao do Destinatario',
        okVariant: 'primary',
        okTitle: 'SIM',
        cancelTitle: 'NAO',
        centered: true
      })

      if (!confirmou) return

      await this.transmitirManifesto(item, tipo, 'Evento Registrado e Vinculado')
    },
    abrirModalJustificativa(item, tipo) {
      this.justificativaNota = item
      this.justificativaTipo = tipo
      this.justificativaTexto = ''
      this.$refs.modalJustificativa.show()
    },
    async executarManifestarComJustificativa(bvModalEv) {
      bvModalEv.preventDefault()
      if (this.justificativaTexto.trim().length < 15) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'A justificativa deve ter ao menos 15 caracteres.')
        return
      }

      this.$refs.modalJustificativa.hide()
      await this.transmitirManifesto(this.justificativaNota, this.justificativaTipo, this.justificativaTexto)
    },
    async transmitirManifesto(item, tipo, justificativa) {
      try {
        this.$store.commit('controle/setAguardando', true)
        const response = await this.$http.post('/api/protected/notaFiscal/distribuicao/manifestar', {
          chaveAcesso: item.CHAVE_ACESSO,
          empresaId: item.EMPRESA_ID || 1,
          tipoManifesto: tipo,
          justificativa,
          usuario: window.localStorage.getItem('login') || 'web'
        }, {
          headers: { login: window.localStorage.getItem('login') }
        })

        if (response.data?.sucesso) {
          Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Manifesto enviado e registrado com sucesso!')
          this.pesquisar()
        }
      } catch (error) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Falha ao manifestar: ' + (error.response?.data || error.message || error))
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async baixarPorChave(item) {
      try {
        this.$store.commit('controle/setAguardando', true)
        const response = await this.$http.post('/api/protected/notaFiscal/distribuicao/baixarPorChave', {
          chaveAcesso: item.CHAVE_ACESSO,
          empresaId: item.EMPRESA_ID || 1,
          usuario: window.localStorage.getItem('login') || 'web'
        })

        if (response.data?.sucesso) {
          Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'XML da nota baixado e processado com sucesso!')
          this.pesquisar()
        }
      } catch (error) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Falha ao baixar XML: ' + (error.response?.data || error.message || error))
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async visualizarDanfe(item) {
      try {
        this.$store.commit('controle/setAguardando', true)
        const response = await this.$http.post('/api/protected/notaFiscal/distribuicao/downloadPDFPelaChave', {
          chaveAcesso: item.CHAVE_ACESSO,
          empresaId: item.EMPRESA_ID || 1
        })

        if (!response.data?.pdfBase64) {
          throw new Error('Retorno do DANFE PDF em branco.')
        }

        const byteCharacters = atob(response.data.pdfBase64)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: 'application/pdf' })
        const fileURL = window.URL.createObjectURL(blob)
        window.open(fileURL)
      } catch (error) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Falha ao visualizar DANFE: ' + (error.message || error))
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async downloadXMLFisico(item) {
      try {
        this.$store.commit('controle/setAguardando', true)
        const response = await this.$http.post('/api/protected/notaFiscal/distribuicao/downloadXMLNfe', {
          chaveAcesso: item.CHAVE_ACESSO,
          empresaId: item.EMPRESA_ID || 1
        })

        const xmlBase64 = response.data?.xmlBase64 || response.data?.pdfBase64
        if (!xmlBase64) {
          throw new Error('Retorno do XML em branco.')
        }

        const link = document.createElement('a')
        link.href = 'data:text/xml;base64,' + xmlBase64
        link.download = `${item.CHAVE_ACESSO}-nfe.xml`
        link.click()
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'XML baixado localmente!')
      } catch (error) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Falha ao baixar XML: ' + (error.message || error))
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    exportarHtml() {
      printHtmlReport({
        rows: this.itensFiltrados,
        columns: this.colunasExportacao,
        systemName: 'CECWeb',
        reportTitle: 'Listagem de Notas Sefaz',
        printedBy: window.localStorage.getItem('login') || '---',
        observations: this.observacoesRelatorio
      })
    },
    exportarExcel() {
      exportExcelXlsx({
        rows: this.itensFiltrados,
        columns: this.colunasExportacao,
        filename: 'nfe-distribuicao-lista.xlsx'
      })
    },
    exportarCsv() {
      exportCsv({
        rows: this.itensFiltrados,
        columns: this.colunasExportacao,
        filename: 'nfe-distribuicao-lista.csv'
      })
    },
    formatarData(valor) {
      if (!valor) return ''
      return Tools.formatarDataBR(valor)
    },
    formatarValor(valor) {
      if (valor === null || typeof valor === 'undefined') return ''
      return Tools.formatCurrency(valor)
    },
    traduzirManifesto(val) {
      if (!val) return 'Nao Manifestado'
      switch (val) {
        case '1':
        case '210200': return 'Confirmacao da Operacao'
        case '2':
        case '210210': return 'Ciencia da Operacao'
        case '3':
        case '210220': return 'Desconhecimento da Operacao'
        case '4':
        case '210240': return 'Operacao nao Realizada'
        default: return val
      }
    },
    traduzirManifestoCor(val) {
      if (!val) return 'secondary'
      switch (val) {
        case '1':
        case '210200': return 'success'
        case '2':
        case '210210': return 'info'
        case '3':
        case '210220': return 'danger'
        case '4':
        case '210240': return 'warning'
        default: return 'dark'
      }
    },
    getTextoStatusManifesto(valor) {
      const item = this.optionsStatusManifesto.find(opcao => opcao.value === valor)
      return item ? item.text : valor
    },
    getTextoAssociacaoCompra(valor) {
      const item = this.optionsAssociacaoCompra.find(opcao => opcao.value === valor)
      return item ? item.text : valor
    },
    somenteNumeros(valor) {
      return String(valor || '').replace(/[^\d]/g, '')
    }
  }
}
</script>

<style scoped>
.btn-icon-only {
  width: 32px;
  height: 32px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.gap-1 {
  gap: 0.25rem;
}

.gap-2 {
  gap: 0.5rem;
}

.gap-3 {
  gap: 1rem;
}

.table-distribuicao-compacta >>> th,
.table-distribuicao-compacta >>> td {
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
}

.table-distribuicao-compacta >>> .badge {
  line-height: 1.1;
}
</style>



// WEBPACK FOOTER //
// src/views/movimentos/compras/NfeDistribuicao.vue